import { categories } from "@/mocks/categories";

export default function CtaSection() {
  return (
    <section className="py-20 md:py-28 px-6 md:px-10 bg-background-50">
      <div className="max-w-3xl mx-auto text-center mb-16">
        <h2 className="font-heading text-3xl md:text-5xl font-semibold text-foreground-950 mb-4">
          Ready to Shop Smarter?
        </h2>
        <p className="text-base md:text-lg text-foreground-500 mb-10 leading-relaxed">
          Join thousands of savvy shoppers using the pandabuyspreadsheet to find better deals, compare products instantly, and never miss a worthy pickup again.
        </p>
        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-2 px-10 py-4 rounded-full bg-primary-500 text-background-50 text-lg font-medium hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
        >
          Buy It Now
          <i className="ri-arrow-right-line text-xl"></i>
        </a>
      </div>

      <div className="max-w-6xl mx-auto">
        <p className="text-center text-xs font-medium text-foreground-400 uppercase tracking-wider mb-6">
          All 14 Product Categories
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="flex items-center gap-2 px-5 py-3 rounded-full bg-background-100 border border-background-200/70 hover:border-primary-300 hover:bg-background-50 transition-all duration-200 cursor-pointer"
            >
              <div className="w-6 h-6 rounded-md overflow-hidden flex-shrink-0">
                <img
                  src={cat.thumbUrl}
                  alt={cat.name}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <span className="text-sm text-foreground-600 font-medium whitespace-nowrap">
                {cat.name}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}